import * as Sentry from "@sentry/react";
import vars from "utils/vars";

Sentry.init({
	dsn: vars.secrets.sentry.key,
	integrations: [
		Sentry.browserTracingIntegration(),
		// Privacy options are pinned explicitly rather than left to the SDK.
		// They currently match the @sentry/replay defaults; stating them here means an
		// SDK upgrade that loosens a default cannot silently start capturing PHI.
		Sentry.replayIntegration({
			maskAllText: true,
			maskAllInputs: true,
			blockAllMedia: true,
			networkDetailAllowUrls: [],
			networkCaptureBodies: false,
		}),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0,
	tracePropagationTargets: ["localhost", new RegExp(`^${vars.app.protocol}://${vars.app.adminDomain}/api`)],
	// Session Replay is error-only (TKT-22393 / Velox Q33). Continuous sampling used to
	// record 10% of all sessions, including patient questionnaire and intake screens.
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
	enabled: vars.isProduction,
});

export default Sentry;
